import { render, staticRenderFns } from "./verificationTable.vue?vue&type=template&id=a40869fc&"
import script from "./verificationTable.vue?vue&type=script&lang=js&"
export * from "./verificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports